import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { MediatorService } from './mediator/mediator.service';
import { AuthenticationService } from 'src/app/core/services/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class AppsService {
  public userComopanies = null;
  private httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  constructor(
    private http: HttpClient,
    private mediatorService: MediatorService,
    private authenticationService: AuthenticationService
  ) { }

  changeAppStatus(appId, newState) {
    const url = '/dashboard/changeappstatus';
    const body = {
      app_id: appId,
      to_state: newState
    };

    return this.http.post<any>(url, body).pipe(
      map((res: Response) => {
        const responseBody = res;
        return responseBody || {};
      })
    );
  }

  fakeResponse(dataName?) {
    return of((new HttpResponse({ status: 200, body: dataName })).body);
  }

  getAppsDetailsCount(cb) {
    this.getAppCount().subscribe(data => {
      cb && cb(data)
    });
  }

  getAppCount() {
    const _this = this;
    const url = '/dashboard/getappcounts';
    return _this.http.get<any>(url).pipe(
      map((res: Response) => {
        const body: any = res;
        const failureData = {
          'is_error': false,
          'api_response': {
            'app_wise_count': {}
          }
        };
        if (!body || body.is_error) {
          return failureData;
        }
        return body;
      })
    );
  }

  getAllApps(): Observable<any> {
    const endpoint = '/dashboard/getusercompanies?dashboard_version=3.0';
    const _this = this;
    return new Observable(observer => {
      if (this.userComopanies) {
        observer.next(this.userComopanies);
        return;
      }
      _this.http.get<any>(endpoint, { ..._this.httpOptions }).subscribe(res => {
        if (this.authenticationService.isIframe()) {
          const companyData = res.api_response.companies[0];
          this.processCompanyDetails(res, companyData);
          observer.next(res);
          return;
        }
        return _this.mediatorService.getObservable('stage_apps', 'enabled').subscribe(flag => {
          if (res.is_error) {
            this.userComopanies = null;
            observer.next(res);
            return res;
          }

          const companyData = res.api_response.companies[0];
          if (flag) {
            companyData.apps.forEach((app) => {
              if (app.env === 'stage') {
                app.env = 'production';
                app.name = 'stage-' + app.name;
              }
            });
          }
          this.processCompanyDetails(res, companyData);
          observer.next(res);
        });
      });
    });
  }

  processCompanyDetails(res, companyData) {
    res.api_response.apps = companyData.apps;
    res.api_response.company_details = {
      email: companyData.email,
      id: companyData.id,
      name: companyData.name,
      workflow_enabled: companyData.workflow_enabled,
      ts: companyData.ts,
      max_live_app_count: companyData.max_live_app_count
    };
    delete res.api_response.companies;
  }
}
